import { Box, Button, TextField, Typography, MenuItem, Select, InputAdornment } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginAsync, selectError } from '../../store/slices/authSlice';
import { useNavigate } from 'react-router';
import Otpverify from '../otpverify';
import { useTranslation } from 'react-i18next';
import axiosInstance from '../../axiosConfig/instance';
import Cookies from 'js-cookie';
import { useDropdownStyle } from '../../hooks/useDropdownStyle';
import styles from "../../style/loginStyle.module.css"
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language);
  const [email, setemail] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [otpForm, setOtpForm] = useState(false);
  const error = useSelector(selectError);
  const { inputStyle, iputType } = useDropdownStyle();

  const handleLanguageChange = (event) => {
    const newLang = event.target.value;
    setCurrentLang(newLang);
    i18n.changeLanguage(newLang);
    //change the language in the axios instance
    axiosInstance.defaults.headers['Accept-Language'] = newLang;
    // Set language in cookie with js-cookie (defaults to 365 days)
    Cookies.set('i18nextLng', newLang, { expires: 365, path: '/' });
  };


  // Handle login submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    await dispatch(loginAsync({ email, password }));
    const storedToken = localStorage.getItem('token');
    // const storedToken = localStorage.getItem('regtoken');

    if (storedToken) {
      navigate('/dashboard');
    }
  };

  // useEffect(() => {
  //   if (error && error.message === 'OTP is not verified') {
  //     setOtp(error.otp);
  //     setOtpForm(true);
  //     localStorage.setItem('regtoken', error.token);
  //   }
  //   // Automatically redirect to OTP form if OTP is required
  //   if (otpForm) {
  //     // Additional check to ensure OTP is set
  //     setOtp(otp);
  //   }
  // }, [error]);
  


  // Handle forgot password
  const handleForgetPassword = (e) => {
    e.preventDefault();
    navigate('/forget');
  };

  // Handle create account
  const handleCreateAccount = (e) => {
    e.preventDefault();
    navigate('/create');
  };

  return (
    <Box sx={{ 
      width: '100%', 
      height: "100vh", 
      textAlign: 'center', 
      overflow: "hidden",
      position: "relative",
      backgroundColor: "FFF9F3"
    }}>
      {/* <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Select
          value={currentLang}
          onChange={handleLanguageChange}
          size="small"
          sx={{ minWidth: 100 }}
        >
          <MenuItem value="en">English</MenuItem>
          <MenuItem value="ar">العربية</MenuItem>
        </Select>
      </Box> */}

        <>
          {/* <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '16px 0',
            }}
            >
            <img
              alt="User Avatar"
              src="/assets/Bask 01-02 1.png"
              style={{ width: 100, height: 75, cursor: 'pointer' }}
              />
          </Box> */}
          {/* <form onSubmit={handleSubmit}>
            <TextField
              label={t('email')}
              variant="outlined"
              fullWidth
              value={email}
              onChange={(e) => setemail(e.target.value)}
              margin="normal"
              inputProps={{
                ...iputType,
                inputMode: 'tel',
                pattern: '[0-9]*'
              }}
              dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
              sx={inputStyle}
            />
            <TextField
              label={t('password')}
              type="password"
              variant="outlined"
              fullWidth
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              margin="normal"
              inputProps={iputType}
              dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
              sx={inputStyle}
            />
            <Button
              type="submit"
              variant="contained"
              sx={{
                backgroundColor: '#C47D60',
                color: 'white',
                width: '30%',
                padding: '10px 20px',
                fontSize: '16px',
                fontWeight: 'bold',
                '&:hover': {
                  backgroundColor: '#A65A42',
                },
                marginBottom: '20px',
              }}
            >
              {t('login')}
            </Button>
            {error && (
              <Typography sx={{ color: 'red', marginBottom: '20px' }}>
                Phone Number or Password Invalid
              </Typography>
            )}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
              <Button
                onClick={handleForgetPassword}
                variant="text"
                sx={{
                  textTransform: 'none',
                  fontSize: '14px',
                  color: '#C47D60',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                {t('forgetPassword')}
              </Button>
              <Button
                onClick={handleCreateAccount}
                variant="text"
                sx={{
                  textTransform: 'none',
                  fontSize: '14px',
                  color: '#C47D60',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                {t('createAccount')}
              </Button>
            </Box>
          </form> */}
          <div className={styles.contentWrapper}>
            <div className={styles.logoBackground}>
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/8d9611c3cf05953aababec0f35a2e61ce7f9fbef"
                alt="Bask Hospitality Logo"
                className={styles.logoImage}
              />
            </div>
            <section className={styles.formContainer}>
              <p className={styles.welcomeHeading}>!Welcome Back </p>
              <form onSubmit={handleSubmit} dir='ltr' style={{ 
                width: '100%', 
                maxWidth: '500px', 
                margin: '0 auto',
                padding: '0 20px' // Add padding for small screens
              }}>
                <label style={{ width: "100%", textAlign: "left", fontSize: "18px", fontWeight: "500" }}>Email</label>
                <TextField
                  variant="outlined"
                  fullWidth
                  value={email}
                  onChange={(e) => setemail(e.target.value)}
                  margin="normal"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                    ...iputType,
                    inputMode: 'email',
                    style: { outline: 'none' }
                  }}
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                  sx={{ ...inputStyle, marginBottom: '10px' ,
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": { borderColor: "gray" }, // لون الإطار العادي
                      "&:hover fieldset": { borderColor: "var(--pri-col)" }, // عند تحريك الماوس فوق الحقل
                      "&.Mui-focused fieldset": { borderColor: "var(--pri-col)", borderWidth: "2px" }, // عند التركيز يصبح أحمر غامق
                    },
                  }}
                />
                <label style={{ width: "100%", textAlign: "left", fontSize: "18px", fontWeight: "500" }}>Password</label>
                <TextField
                  type="password"
                  variant="outlined"
                  fullWidth
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  margin="normal"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockIcon />
                      </InputAdornment>
                    ),
                    ...iputType,
                    style: { outline: 'none' }
                  }}
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                  sx={{ ...inputStyle, marginBottom: '10px' ,
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": { borderColor: "gray" }, // لون الإطار العادي
                      "&:hover fieldset": { borderColor: "var(--pri-col)" }, // عند تحريك الماوس فوق الحقل
                      "&.Mui-focused fieldset": { borderColor: "var(--pri-col)", borderWidth: "2px" }, // عند التركيز يصبح أحمر غامق
                    },
                  }}
                />
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    backgroundColor: 'var(--pri-col)',
                    color: 'white',
                    width: '100%',
                    padding: '10px 20px',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    borderRadius:"12px",
                    marginTop:"1rem",
                    '&:hover': {
                      backgroundColor: 'var(--pri-col)',
                    },
                    marginBottom: '20px',
                  }}
                >
                  login
                </Button>
                {error && (
                  <Typography sx={{ color: 'red', marginBottom: '20px' }}>
                    Email or Password Invalid
                  </Typography>
                )}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                  {/* Forget Password --------------------------------------------------------------------*/}
                  {/* <Button
                    onClick={handleForgetPassword}
                    variant="text"
                    sx={{
                      textTransform: 'none',
                      fontSize: '14px',
                      color: '#C47D60',
                      '&:hover': { textDecoration: 'underline' },
                    }}
                  >
                    {t('forgetPassword')}
                  </Button> */}

                  <Button
                    onClick={handleCreateAccount}
                    variant="text"
                    sx={{
                      direction: "ltr",
                      textTransform: 'none',
                      fontSize: '16px',
                      fontWeight:"800",
                      color: 'var(--pri-col)',
                      '&:hover': {},
                    }}
                  >
                    <span style={{ color: "#615C5A",fontWeight:"400", pointerEvents: "none"}}>Don't have an account? </span>
                    &nbsp; Create an account
                  </Button>
                </Box>
              </form>
            </section>
          </div>
        </>
      
      <img 
        src="../../assets/Bask 01-04 1.png" 
        className='img-left'
        style={{ 
          width: "clamp(150px, 15vw, 229px)", 
          height: "auto", 
          position: "absolute", 
          top: "0px", 
          left: "0px",
          transform: "rotate(180deg)",
          display: { xs: 'none', md: 'block' } // Hide on mobile
        }} 
      />
      <img 
        src="../../assets/image 4.png" 
        className='img-right'
        style={{ 
          width: "clamp(200px, 20vw, 304px)", 
          height: "auto", 
          position: "absolute", 
          top: "2rem", 
          right: "clamp(1rem, 5vw, 5rem)",
          display: { xs: 'none', md: 'block' } // Hide on mobile
        }} 
      />
    </Box>
  );
}
